module.exports = __webpack_public_path__ + "img/callcenterReportes.59eb62bb.png";